import './App.css';
import AboutSide from './Components/AboutSide/AboutSide';
import MainContainer from './Components/MainContainer/MainContainer'

function App() {
  return (
    <div className='containers'>
      <AboutSide />
      <MainContainer />
    </div>


  );
}

export default App;
